import React from "react";

class Footer extends React.Component {
  render() {
    return (
      <footer id="footer" className="footer-2 light">
        <div className="w-container">
          <div className={"legal" + (this.props.confirmation ? " confirm" : " lightbg")}>
            © {new Date().getFullYear()} Duos Living. All rights reserved.
            <br />
            <a
              href="https://getduos.com/terms-of-service"
              target="_blank"
              rel="noreferrer"
              className={this.props.confirmation ? "legal" : ""}
            >
              Terms of Service
            </a>{" "}
            &nbsp;| &nbsp;
            <a
              href="https://getduos.com/privacy-policy"
              target="_blank"
              rel="noreferrer"
              className={this.props.confirmation ? "legal" : ""}
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
